import axios from 'axios'

let setAuthorizationToken = (token) => {
  console.log('Changed `X-Auth-Token` to:', token)
  if (token) {
    API.defaults.headers.common['X-Auth-Token'] = token
    // API.defaults.headers.common['x-auth-token'] = token
  } else {
    delete API.defaults.headers.common['X-Auth-Token']
    // delete API.defaults.headers.common['x-auth-token']
  }
}

const configElement = document.getElementById('config')
const configFromHtml = JSON.parse(configElement.innerHTML)
console.log('config', configFromHtml)
window.configECP = configFromHtml

const API = axios.create({
  baseURL: window.configECP.baseURL + '/api',
})

export {
  setAuthorizationToken,
  API,
}



// WEBPACK FOOTER //
// ./src/api/axios.js